var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.timeslot
            ? _c("patient-loading")
            : _c("div", { staticClass: "card" }, [
                _vm.step == "timeslotDetails"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-6" }, [
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-blue text-sm font-semibold mb-1"
                              },
                              [_vm._v(_vm._s(_vm.$t("When_")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-black font-semibold text-lg"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentFormat")(
                                      _vm.timeslot.date,
                                      "YYYY-MM-DD",
                                      _vm.$t("date_selector_format")
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("at")) +
                                    " " +
                                    _vm._s(
                                      _vm._f("momentFormatTime")(
                                        _vm.timeslot.time,
                                        _vm.$t("time_format")
                                      )
                                    )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-4 flex justify-between" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Who_will_treat_me_"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-grey-darkest" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timeslot.doctorFirstName +
                                            " " +
                                            _vm.timeslot.doctorLastName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-sm text-grey-darker" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("type_" + _vm.timeslot.type)
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.timeslot.isDoctorRegulated &&
                                  (_vm.timeslot.type !== "OSTEOPATH" &&
                                    _vm.timeslot.type !== "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-green font-semibold text-sm mt-1"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("Contracted_doctor")
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.timeslot.isDoctorRegulated &&
                                  (_vm.timeslot.type !== "OSTEOPATH" &&
                                    _vm.timeslot.type !== "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-red font-semibold text-sm mt-1"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Contracted_doctor_negative"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.timeslot.isDoctorMemberOfOsteopathie
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tooltip text-green font-semibold text-sm mt-1 mb-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-check-circle"
                                          }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("Member_of_Osteopathie")
                                              ) +
                                              "\n                                    "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip-text text-sm"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Oste_tooltip"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.timeslot.officeSettings
                                    ? _c("OfficeSettings", {
                                        attrs: {
                                          accessible:
                                            _vm.timeslot.officeSettings
                                              .accessible,
                                          card:
                                            _vm.timeslot.officeSettings.card,
                                          cash: _vm.timeslot.officeSettings.cash
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("avatar", {
                                staticClass: "ml-2 w-10 h-10",
                                attrs: {
                                  avatar: _vm.timeslot.doctorAvatar,
                                  name:
                                    _vm.timeslot.doctorFirstName +
                                    " " +
                                    _vm.timeslot.doctorLastName
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-blue text-sm font-semibold mb-1"
                              },
                              [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-grey-darkest" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.timeslot.officeStreetNumber) +
                                  " " +
                                  _vm._s(_vm.timeslot.officeStreetName)
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.timeslot.officeZipCode) +
                                  " " +
                                  _vm._s(_vm.timeslot.officeLocality) +
                                  "\n                            "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "gmap-map",
                          {
                            staticClass: "w-full",
                            staticStyle: { height: "250px" },
                            attrs: {
                              center: {
                                lat: _vm.timeslot.officeLocation._lat,
                                lng: _vm.timeslot.officeLocation._long
                              },
                              zoom: 13,
                              options: { disableDefaultUI: true }
                            }
                          },
                          [
                            _c("gmap-marker", {
                              attrs: {
                                position: {
                                  lat: _vm.timeslot.officeLocation._lat,
                                  lng: _vm.timeslot.officeLocation._long
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isBooked
                          ? _c("div", { staticClass: "px-6 py-4" }, [
                              _vm.userId
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                      on: {
                                        click: function($event) {
                                          return _vm.changeStep("patientForm")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Book_this_appointment"))
                                      )
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                      on: { click: _vm.showLogin }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Sign_in_to_book_this_appointment"
                                          )
                                        )
                                      )
                                    ]
                                  )
                            ])
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "px-6 py-4 bg-teal text-center rounded-b"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Appointment_confirmed"))
                                    )
                                  ]
                                )
                              ]
                            )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "patientForm"
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitPatientForm($event)
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.changeStep("timeslotDetails")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-arrow-left" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-6 pt-12" }, [
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Firstname_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.firstName,
                                  expression: "patientForm.firstName"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("first_name")
                              },
                              attrs: { name: "first_name", type: "text" },
                              domProps: { value: _vm.patientForm.firstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "firstName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("first_name"),
                                    expression: "errors.has('first_name')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Please_fill_your_first_name"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Lastname_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.lastName,
                                  expression: "patientForm.lastName"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("last_name")
                              },
                              attrs: { name: "last_name", type: "text" },
                              domProps: { value: _vm.patientForm.lastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "lastName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("last_name"),
                                    expression: "errors.has('last_name')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Please_fill_your_last_name"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Age_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.age,
                                  expression: "patientForm.age"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "'required|numeric'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("patientForm.age")
                              },
                              attrs: {
                                name: "patientForm.age",
                                type: "number",
                                step: "1",
                                min: "0"
                              },
                              domProps: { value: _vm.patientForm.age },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "age",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("patientForm.age"),
                                    expression: "errors.has('patientForm.age')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [_vm._v(_vm._s(_vm.$t("Please_fill_your_age")))]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.patient || _vm.patient.email === null
                            ? _c("div", { staticClass: "mb-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Email_address_")))]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.patientForm.email,
                                      expression: "patientForm.email"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email",
                                      expression: "'required|email'"
                                    }
                                  ],
                                  staticClass:
                                    "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                  class: {
                                    "border-red": _vm.errors.has("email")
                                  },
                                  attrs: { name: "email", type: "email" },
                                  domProps: { value: _vm.patientForm.email },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.patientForm,
                                        "email",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("email"),
                                        expression: "errors.has('email')"
                                      }
                                    ],
                                    staticClass:
                                      "text-xs text-red font-semibold"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Please_fill_your_email_address")
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Phone_number_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.phone,
                                  expression: "patientForm.phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|phone:BE",
                                  expression: "'required|phone:BE'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: { "border-red": _vm.errors.has("phone") },
                              attrs: { name: "phone", type: "phone" },
                              domProps: { value: _vm.patientForm.phone },
                              on: {
                                blur: _vm.transformPhone,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "phone",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("phone"),
                                    expression: "errors.has('phone')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Please_fill_your_phone_number")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                              attrs: { type: "submit" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Next")))]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "patientSymptoms"
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitPatientSymptoms($event)
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.changeStep("patientForm")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-arrow-left" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.timeslot.type === "DENTIST"
                          ? _c(
                              "div",
                              { staticClass: "p-6 pt-12" },
                              [
                                _vm._l([0, 1, 2, 3, 4], function(qIndex) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap -mx-4" },
                                      _vm._l(
                                        _vm.questions[qIndex].choices,
                                        function(answer, index) {
                                          return _c(
                                            "label",
                                            {
                                              key: index,
                                              staticClass:
                                                "block group mb-2 px-4",
                                              class:
                                                [2, 3, 4].indexOf(qIndex) >= 0
                                                  ? "w-1/2"
                                                  : "w-full"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.questions[qIndex]
                                                        .answer,
                                                    expression:
                                                      "questions[qIndex].answer"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass: "mr-2",
                                                attrs: {
                                                  type: "radio",
                                                  name: "symptomsForm." + qIndex
                                                },
                                                domProps: {
                                                  value: answer,
                                                  checked: _vm._q(
                                                    _vm.questions[qIndex]
                                                      .answer,
                                                    answer
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.$set(
                                                      _vm.questions[qIndex],
                                                      "answer",
                                                      answer
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "text-sm",
                                                class:
                                                  _vm.questions[qIndex]
                                                    .answer == answer
                                                    ? "text-black"
                                                    : "text-grey-dark group-hover:text-grey-darkest",
                                                domProps: {
                                                  textContent: _vm._s(answer)
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "symptomsForm." + qIndex
                                            ),
                                            expression:
                                              "errors.has('symptomsForm.' + qIndex)"
                                          }
                                        ],
                                        staticClass:
                                          "text-xs text-red font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Please_specify")))]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _vm._l([5, 6], function(qIndex) {
                                  return _vm.questions[4].answer ==
                                    _vm.$t("SYMPTOMS_ANSWER_5_1")
                                    ? _c("div", { staticClass: "mb-4" }, [
                                        _c("div", {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.questions[qIndex].label
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-wrap -mx-4"
                                          },
                                          _vm._l(
                                            _vm.questions[qIndex].choices,
                                            function(answer, index) {
                                              return _c(
                                                "label",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "block group mb-2 px-4",
                                                  class:
                                                    [2, 3, 4].indexOf(qIndex) >=
                                                    0
                                                      ? "w-1/2"
                                                      : "w-full"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.questions[qIndex]
                                                            .answer,
                                                        expression:
                                                          "questions[qIndex].answer"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "radio",
                                                      name:
                                                        "symptomsForm." + qIndex
                                                    },
                                                    domProps: {
                                                      value: answer,
                                                      checked: _vm._q(
                                                        _vm.questions[qIndex]
                                                          .answer,
                                                        answer
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          _vm.questions[qIndex],
                                                          "answer",
                                                          answer
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "text-sm",
                                                    class:
                                                      _vm.questions[qIndex]
                                                        .answer == answer
                                                        ? "text-black"
                                                        : "text-grey-dark group-hover:text-grey-darkest",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        answer
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "symptomsForm." + qIndex
                                                ),
                                                expression:
                                                  "errors.has('symptomsForm.' + qIndex)"
                                              }
                                            ],
                                            staticClass:
                                              "text-xs text-red font-semibold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Please_specify"))
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Next")))]
                                )
                              ],
                              2
                            )
                          : _c(
                              "div",
                              { staticClass: "p-6 pt-12" },
                              [
                                _vm._l(_vm.questions, function(
                                  question,
                                  qIndex
                                ) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questions[qIndex].answer,
                                              expression:
                                                "questions[qIndex].answer"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass:
                                            "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                          attrs: {
                                            name: "symptomsForm." + qIndex,
                                            rows: "5"
                                          },
                                          domProps: {
                                            value: _vm.questions[qIndex].answer
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.questions[qIndex],
                                                "answer",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "symptomsForm." + qIndex
                                            ),
                                            expression:
                                              "errors.has('symptomsForm.' + qIndex)"
                                          }
                                        ],
                                        staticClass:
                                          "text-xs text-red font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Please_specify")))]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Next")))]
                                )
                              ],
                              2
                            )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submissionSummary"
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                          on: {
                            click: function($event) {
                              return _vm.changeStep("patientSymptoms")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-arrow-left" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "px-6 py-4" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "text-xl uppercase tracking-wide text-grey-darkest"
                          },
                          [_vm._v(_vm._s(_vm.$t("Summary")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p-6 pt-4" }, [
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Name")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(
                                _vm.patientForm.firstName +
                                  " " +
                                  _vm.patientForm.lastName
                              )
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Age")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.age)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Email_address")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.email)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Phone_number")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.phone)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm.timeslot.type === "DENTIST"
                          ? _c(
                              "div",
                              [
                                _vm._l([0, 1, 2, 3, 4], function(qIndex) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "text-sm text-grey-darker",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.questions[qIndex].answer
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _vm._l([5, 6], function(qIndex) {
                                  return _vm.questions[4].answer ==
                                    _vm.$t("SYMPTOMS_ANSWER_5_1")
                                    ? _c("div", { staticClass: "mb-4" }, [
                                        _c("div", {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.questions[qIndex].label
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-wrap" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "text-sm text-grey-darker",
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.questions[qIndex].answer
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _c(
                              "div",
                              _vm._l(_vm.questions, function(question, qIndex) {
                                return _c("div", { staticClass: "mb-4" }, [
                                  _c("div", {
                                    staticClass:
                                      "text-blue text-sm font-semibold mb-2",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.questions[qIndex].label
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex flex-wrap" }, [
                                    _c("span", {
                                      staticClass: "text-sm text-grey-darker",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.questions[qIndex].answer
                                        )
                                      }
                                    })
                                  ])
                                ])
                              }),
                              0
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "relative" },
                          [
                            _c("bubble", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "The_practitioner_will_be_informed_immediately_of_your_reservation"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3 mt-6",
                                on: { click: _vm.confirmReservation }
                              },
                              [_vm._v(_vm._s(_vm.$t("Confirm")))]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submitting"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "flex items-center justify-center h-64"
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-grey" },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-loading mdi-spin"
                                })
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-grey-darker mt-4" },
                              [_vm._v(_vm._s(_vm.$t("Loading")))]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submitted"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-white" },
                              [_c("i", { staticClass: "mdi mdi-verified" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-xl ml-4" },
                              [_vm._v(_vm._s(_vm.$t("Appointment_confirmed")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submissionError"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-white" },
                              [_c("i", { staticClass: "mdi mdi-alert-circle" })]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "text-sm text-xl ml-4",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.errorText
                                    ? _vm.errorText
                                    : _vm.$t("an_error_occured")
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
          _vm._v(" "),
          _vm.step == "submitted"
            ? _c(
                "div",
                { staticClass: "mt-3 text-sm text-center text-grey-dark" },
                [_vm._v(_vm._s(_vm.$t("Redirecting")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.timeslot
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/TimeslotShow",
                  size: [300, 250],
                  id: "div-gpt-ad-timeslot",
                  "medical-practice": _vm.timeslot.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d06e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d06e02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/TimeslotShow.vue
// module id = 769
// module chunks = 1